import { render } from "./ToolbarComp.vue?vue&type=template&id=1087f416&scoped=true"
import script from "./ToolbarComp.vue?vue&type=script&lang=js"
export * from "./ToolbarComp.vue?vue&type=script&lang=js"

import "./ToolbarComp.vue?vue&type=style&index=0&id=1087f416&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1087f416"]])

export default __exports__